var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lada-items-moderation"},[_vm._l((_vm.data.rows),function(document){return [(document.data.status === 'NEW')?_c('lada-new-item-card',{key:document.id,staticClass:"lada-items__item",attrs:{"data":document,"entityFields":_vm.entityFields},on:{"updateStatus":_vm.updateStatus}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }